"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("../../type/entity");
const getInteractionKey_1 = require("./getInteractionKey");
function getFeedbackInteraction(param) {
    try {
        const { teacherId, studentId, timeStamp, actorType, feedbackText, companyId, submissionId, cardQuestionId, rootContentId, isAnonymous } = param;
        const feedbackInteraction = {
            actorId: teacherId,
            actorType,
            companyId,
            contentId: cardQuestionId,
            contentId_interactionType_interactingOnId_actorId: getInteractionKey_1.getInteractionKeyForLearner(cardQuestionId, entity_1.InteractionType.Feedback, submissionId, teacherId),
            createdAt: timeStamp,
            deleted: false,
            feedbackText,
            interactionType: entity_1.InteractionType.Feedback,
            interactionType_contentId_interactingOnId_userId: getInteractionKey_1.getInteractionKeyForActorId(cardQuestionId, entity_1.InteractionType.Feedback, submissionId, studentId),
            isAnonymous,
            rootContentId,
            submissionId,
            updatedAt: timeStamp,
            userId: studentId,
            versionNumber: 0
        };
        return feedbackInteraction;
    }
    catch (error) {
        throw new Error('Error in FeedbackInteraction ' + error);
    }
}
exports.getFeedbackInteraction = getFeedbackInteraction;
//# sourceMappingURL=feedbackInteraction.js.map